import angular from 'angular'
import { EntityStore } from './entity-store'

export interface ApiCustomerTax {
  customer_id: string
  tax_id: string | null // tax_id will be null for deleted customer tax
  tax_note: string | null
  deleted_at: string | null
  version: number
}
/**
 * Stores information on the retailer's customer taxes for the current active
 * outlet.
 */
export class CustomerTaxesStore extends EntityStore<'customerTaxes'> {
  constructor() {
    'ngInject'
    super({
      entityStoreName: 'customerTaxes',
      entityName: 'customer_taxes',
    })
  }

  /**
   * Remove the given customer tax from the IndexedDB store. Overridden as need to remove by
   * `customer_id` instead of `id`.
   *
   * @param  entity
   *         The customer tax to remove from the store
   *
   * @return A promise resolved once the customer tax has been successfully removed
   */
  protected removeEntity(entity: ApiCustomerTax) {
    return this.dbStore.del(entity.customer_id)
  }
}

angular
  .module('webregister.factories')
  .service('customerTaxesStore', CustomerTaxesStore)
